import { memo } from 'react';
import type {
  PropsWithChildren,
  ReactElement,
} from 'react';

import {
  buttonColors,
} from '../Button';

import { useRemoveButton } from '../useRemoveButton';
import type {
  UseRemoveButtonParams,
} from '../useRemoveButton';

export type RemoveTableActionProps = UseRemoveButtonParams & PropsWithChildren<{
  /**
   * Выключена ли кнопка
   */
  disabled?: boolean;
  /**
   * css-класс кнопки
   */
  className?: string;
  /**
   * html-атрибут
   */
  title?: string;
}>;

function RemoveTableActionInner({
  className = '',
  title = '',
  children = undefined,
  disabled = false,
  remove,
  onRemoveSuccess = undefined,
  approveTitle = undefined,
  approveContent = undefined,
  approveButtonText,
  approveButtonColor = buttonColors.DANGER,
  cancelButtonText,
  errorsPath = 'response.data.detail',
  redirectTo = undefined,
  notification = undefined,
}: RemoveTableActionProps): ReactElement {
  const {
    isRemoving,
    onClick,
  } = useRemoveButton({
    remove,
    onRemoveSuccess,
    approveTitle,
    approveContent,
    approveButtonText,
    approveButtonColor,
    cancelButtonText,
    errorsPath,
    redirectTo,
    notification,
  });

  return (
    <button
      type="button"
      disabled={disabled || isRemoving}
      onClick={onClick}
      className={className}
      title={title}
    >
      {children}
    </button>
  );
}

export const RemoveTableAction = memo(RemoveTableActionInner);
